import { SelectOption } from '@/components/form-builder/form-builder.types';
import { DacPrixRequest } from '@/types';
import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { Observable, of } from 'rxjs';
import { Select } from 'primeng/select';

@Component({
  selector: 'sm-dac-prix-form',
  standalone: true,
  imports: [InputNumberModule, ButtonModule, CommonModule, FormsModule, TranslateModule, Select],
  templateUrl: './dac-prix-form.component.html',
  styleUrl: './dac-prix-form.component.scss',
})
export class DacPrixFormComponent implements OnInit {
  @Input() value: Observable<DacPrixRequest[]> = of([]);
  @Input() onChange?: (event: DacPrixRequest[]) => void;
  @Input() errors: Observable<{ monnaieId: string; prix: string }[]> = of([]);
  @Input() disabled = of(false);
  @Input() globalError: Observable<string> = of('');
  @Input() currencyOptions: SelectOption[] = [];

  dacPrixList: DacPrixRequest[] = [];
  uid = new Date().getTime();

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.value.subscribe(prices => {
      this.dacPrixList = (prices || []).map(price => ({ ...price }));
    });
  }

  addDacPrix() {
    this.dacPrixList.push({ monnaieId: 0, prix: 0 });
    this.onChange?.([...this.dacPrixList]);
  }

  updateMonnaie(index: number, newValue: number) {
    this.dacPrixList[index].monnaieId = newValue;
    this.onChange?.([...this.dacPrixList]);
  }

  updatePrix(index: number, newValue: number) {
    this.dacPrixList[index].prix = newValue;
    this.onChange?.([...this.dacPrixList]);
  }

  removeDacPrix(index: number) {
    this.dacPrixList.splice(index, 1);
    this.onChange?.([...this.dacPrixList]);
  }

  clearAllDacPrix() {
    this.dacPrixList = [];
    this.onChange?.([]);
  }

  trackByFn(index: number) {
    return index;
  }

  protected readonly of = of;
}
